import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  height: theme.typography.pxToRem(955),
  position: 'relative',
  [theme.breakpoints.down('md')]: {
    height: '100vh',
  },
  '& .HSBGContainer': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },
  '& .HSBGGradient': {
    background:
      'linear-gradient(180deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.00) 12.86%), linear-gradient(180deg, rgba(0, 0, 0, 0.00) 44.12%, #000 100%), radial-gradient(50% 50% at 50% 49.89%, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.45) 100%)',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
  },
  '& .HSContentContainer': {
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    zIndex: 5,
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(0, 3),
    },
  },

  '& .HSWidgetContainer': {
    width: 'max(70% , 1000px)',
    margin: 'auto',
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      width: 'max(90% , 600px)',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  '& .HSFixedButton': {
    position: 'fixed',
    bottom: '0',
    left: '0',
    width: '100%',
    zIndex: 99,
    borderRadius: 0,
    height: theme.spacing(6.25),
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(15),
    textTransform: 'uppercase',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default StyledBox;
